import React from "react";
import { Table } from "../../generated/core-api";
import styles from "./TableView.module.css";

type TableViewProps = {
  table: Table;
};

export const TableView: React.FC<TableViewProps> = ({ table }) => {
  // Defensive checks for partial/streaming data
  const headers = Array.isArray(table.headers) ? table.headers : [];
  const rows = Array.isArray(table.rows) ? table.rows : [];

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index} className={styles.th}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            // Skip non-array rows (can happen during streaming)
            if (!Array.isArray(row)) {
              return null;
            }
            return (
              <tr key={rowIndex} className={styles.tr}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex} className={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
